globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { useState } from 'react';
import Image from 'next/image';
import { PhotoIcon } from '@heroicons/react/24/solid';
import { MapPinIcon } from '@heroicons/react/24/outline';
import { customImageLoader, useResponsiveBreakPoints } from '@restworld/utils-common';
import { Badge } from '@restworld/ui-ds-base';
import Title from '../title';
import { ButtonV2 } from '../button-v2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function EmployerCandidateCard(_ref) {
  var children = _ref.children,
      ctaButton = _ref.ctaButton,
      twStyle = _ref.twStyle;

  var _useState = useState(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1];

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo.isDesktop;

  return /*#__PURE__*/_jsxs(CardContainer, {
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    onClick: ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.onClick,
    twStyle: twStyle,
    children: [children, isDesktop && /*#__PURE__*/_jsx(CardFooterWrapper, {
      isHovered: isHovered,
      children: /*#__PURE__*/_jsx(ButtonV2, {
        fullwidth: true,
        size: "sm",
        children: ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.label
      })
    })]
  });
}
export function EmployerCandidateCardHeader(_ref2) {
  var firstName = _ref2.firstName,
      lastName = _ref2.lastName;
  return /*#__PURE__*/_jsxs(CardHeaderWrapper, {
    children: [/*#__PURE__*/_jsx(Title, {
      fontSize: "small",
      fontWeight: "semibold",
      twStyle: {
        "fontSize": "0.875rem",
        "lineHeight": "1.5",
        "--tw-text-opacity": "1",
        "color": "rgb(28 28 51 / var(--tw-text-opacity))"
      },
      children: firstName
    }), /*#__PURE__*/_jsx(Title, {
      fontSize: "small",
      fontWeight: "semibold",
      twStyle: {
        "fontSize": "0.875rem",
        "lineHeight": "1.5",
        "--tw-text-opacity": "1",
        "color": "rgb(28 28 51 / var(--tw-text-opacity))"
      },
      children: lastName
    })]
  });
}
export function EmployerCandidateCardInfo(_ref3) {
  var candidateImage = _ref3.candidateImage,
      badge = _ref3.badge,
      distance = _ref3.distance;
  return /*#__PURE__*/_jsxs(CardInfoWrapper, {
    children: [/*#__PURE__*/_jsx(CandidateImageWrapper, {
      children: candidateImage ? /*#__PURE__*/_jsx(_StyledImage, {
        src: candidateImage || '',
        alt: "",
        fill: true,
        loader: customImageLoader
      }) : /*#__PURE__*/_jsx(CandidateImagePlaceholder, {})
    }), /*#__PURE__*/_jsxs(BadgeAndDistanceWrapper, {
      children: [/*#__PURE__*/_jsx(BadgeWrapper, {
        children: /*#__PURE__*/_jsx(Badge, {
          variant: badge.variant,
          children: "".concat(badge.text, " ").concat(badge.variant === 'fresh' ? '🎉' : '')
        })
      }), /*#__PURE__*/_jsx(DistanceWrapper, {
        children: distance && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(_StyledMapPinIcon, {}), /*#__PURE__*/_jsx(DistanceText, {
            children: distance
          })]
        })
      })]
    })]
  });
}
export function EmployerCandidatesCardLabels(_ref4) {
  var labels = _ref4.labels,
      variant = _ref4.variant;
  return /*#__PURE__*/_jsx(LabelsWrapper, {
    children: labels.map(function (label, i) {
      return label ? /*#__PURE__*/_jsx(BadgeWrapper, {
        children: /*#__PURE__*/_jsx(Badge, {
          variant: variant,
          children: label
        })
      }, i) : null;
    })
  });
}

var CandidateImagePlaceholder = function CandidateImagePlaceholder() {
  return /*#__PURE__*/_jsx(CandidateImagePlaceholderWrapper, {
    children: /*#__PURE__*/_jsx(_StyledPhotoIcon, {})
  });
};

export default EmployerCandidateCard;

var CardContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__CardContainer",
  componentId: "sc-1ono913-0"
})(["", " ", " ", " ", ""], {
  "position": "relative",
  "boxSizing": "border-box",
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.75rem",
  "borderRadius": "1rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingBottom": "1rem",
  "paddingTop": "1.25rem",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms",
  ":hover": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(102 51 187 / var(--tw-border-opacity))",
    "--tw-shadow": "inset 0 0 0 3px #6633bb",
    "--tw-shadow-colored": "inset 0 0 0 3px var(--tw-shadow-color)",
    "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
  }
}, {
  "width": "100%"
}, function (_ref5) {
  var twStyle = _ref5.twStyle;
  return twStyle ? twStyle : {};
}, {
  "cursor": "pointer"
});

var CardHeaderWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__CardHeaderWrapper",
  componentId: "sc-1ono913-1"
})(["", ""], {});

var CardInfoWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__CardInfoWrapper",
  componentId: "sc-1ono913-2"
})(["", ""], {
  "marginBottom": "0.25rem",
  "display": "flex",
  "gap": "0.75rem"
});

var CandidateImageWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__CandidateImageWrapper",
  componentId: "sc-1ono913-3"
})(["", ""], {
  "position": "relative",
  "display": "flex",
  "height": "4rem",
  "width": "4rem",
  "minWidth": "4rem",
  "alignItems": "center",
  "justifyContent": "center",
  "overflow": "hidden",
  "borderRadius": "0.5rem",
  "objectFit": "cover",
  "objectPosition": "center"
});

var CandidateImagePlaceholderWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__CandidateImagePlaceholderWrapper",
  componentId: "sc-1ono913-4"
})(["", ""], {
  "zIndex": "5",
  "display": "grid",
  "height": "4rem",
  "width": "4rem",
  "placeItems": "center",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))"
});

var BadgeAndDistanceWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__BadgeAndDistanceWrapper",
  componentId: "sc-1ono913-5"
})(["", ""], {});

var BadgeWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__BadgeWrapper",
  componentId: "sc-1ono913-6"
})(["", ""], {
  "minWidth": "fit-content",
  "maxWidth": "fit-content",
  "whiteSpace": "nowrap"
});

var CardFooterWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__CardFooterWrapper",
  componentId: "sc-1ono913-7"
})(["", " ", ""], {
  "position": "absolute",
  "bottom": "0.5rem",
  "left": "3px",
  "right": "3px",
  "zIndex": "5",
  "display": "grid",
  "height": "3.75rem",
  "placeItems": "center",
  "borderBottomRightRadius": "1rem",
  "borderBottomLeftRadius": "1rem",
  "borderTopWidth": "1px",
  "--tw-border-opacity": "1",
  "borderTopColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "opacity": "0",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "200ms"
}, function (_ref6) {
  var isHovered = _ref6.isHovered;
  return isHovered ? {
    "bottom": "3px",
    "opacity": "1"
  } : {};
});

var DistanceWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__DistanceWrapper",
  componentId: "sc-1ono913-8"
})(["", ""], {
  "marginTop": "0.5rem",
  "display": "flex",
  "alignItems": "center"
});

var DistanceText = /*#__PURE__*/_styled.p.withConfig({
  displayName: "employer-candidate-card__DistanceText",
  componentId: "sc-1ono913-9"
})(["", ""], {
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});

var LabelsWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__LabelsWrapper",
  componentId: "sc-1ono913-10"
})(["", ""], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "0.25rem"
});

var _StyledImage = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "employer-candidate-card___StyledImage",
  componentId: "sc-1ono913-11"
})({
  "objectFit": "cover",
  "objectPosition": "center"
});

var _StyledMapPinIcon = /*#__PURE__*/_styled(MapPinIcon).withConfig({
  displayName: "employer-candidate-card___StyledMapPinIcon",
  componentId: "sc-1ono913-12"
})({
  "height": "1rem",
  "width": "1rem",
  "stroke": "#666676"
});

var _StyledPhotoIcon = /*#__PURE__*/_styled(PhotoIcon).withConfig({
  displayName: "employer-candidate-card___StyledPhotoIcon",
  componentId: "sc-1ono913-13"
})({
  "height": "1.5rem",
  "width": "1.5rem",
  "fill": "#482485"
});